export default __webpack_public_path__ + "static/media/Roboto-BoldItalic.894ce0e6.ttf";